export default {
    expires : '365',
    path : '/'
}
